"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessage = void 0;
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _defaultTranslations = require("../constants/defaultTranslations");
var _TranslationKey = require("../models/TranslationKey");
var _Localization = require("./Localization");
var _jsxRuntime = require("react/jsx-runtime");
const StyledLink = (0, _mui.styled)('a')(({
  theme
}) => ({
  color: theme.palette.error.main,
  textDecoration: 'underline',
  fontWeight: 'bold',
  '&:hover': {
    color: theme.palette.error.main,
    textDecoration: 'underline'
  }
}));
const ErrorMessage = props => {
  const {
    errorMessage,
    customerLoginUrl,
    maxDate
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
    namespace: _defaultTranslations.translationsNamespace,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
      error: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        ...errorMessage,
        values: {
          loginLink: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, {
            href: customerLoginUrl,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              id: _TranslationKey.TranslationKey.loginLinkLabel,
              defaultMessage: _defaultTranslations.defaultTranslations.loginLinkLabel
            })
          }),
          max: maxDate
        }
      })
    })
  });
};
exports.ErrorMessage = ErrorMessage;
